import type { AnalysisResult } from '@lognai/plugin-analytics-ui';
import type { WorkspaceCardContent } from '../../services/api/workspace';

/** Describe shape for layout decisions without sending business records to the planner. */
export function chartWorkspaceContent(result: AnalysisResult | undefined, failed = false): WorkspaceCardContent {
  if (failed) return { state: 'error' };
  if (!result) return { state: 'loading' };
  const points = result.visual.series[0]?.points ?? [];
  const columns = new Set([...result.analysis.dimensions, ...result.analysis.measures, ...(result.analysis.timeDimension ? [result.analysis.timeDimension.member] : [])]);
  return {
    state: points.length ? 'populated' : 'empty',
    itemCount: points.length, categoryCount: points.length, columnCount: columns.size,
    seriesCount: result.visual.series.length, template: result.visual.template,
  };
}
